module.exports = __webpack_public_path__ + "img/fifty-shades-of-grey.538b482c.jpg";